export default "__VITE_ASSET__CbHIPVla__"